import Departments from '../../common/models/Departments';

const SizeGuideHeader = ({ department }) => {
  const defaultSizeGuideHeader = 'Size Guide';

  switch (department) {
    case Departments.getMenInternalName():
    case Departments.getWomenInternalName():
      return `${Departments.getNameAsPossessiveNoun(department)} ${defaultSizeGuideHeader}`;
  }

  if (!Departments.getKidsDepartmentsInternalNames().includes(department)) {
    return defaultSizeGuideHeader;
  }

  let kidsHeaderPostfix = '';
  switch (department) {
    case Departments.getGirlsInternalName():
    case Departments.getBoysInternalName():
      const girls = Departments.getName(Departments.getGirlsInternalName());
      const boys = Departments.getName(Departments.getBoysInternalName());
      kidsHeaderPostfix += ` - ${girls} & ${boys}`;
      break;
    case Departments.getBabyGirlsInternalName():
    case Departments.getBabyBoysInternalName():
      const babyGirls = Departments.getName(Departments.getBabyGirlsInternalName());
      const babyBoys = Departments.getName(Departments.getBabyBoysInternalName());
      kidsHeaderPostfix += ` - ${babyGirls} & ${babyBoys}`;
      break;
  }

  const possessiveNoun = Departments.getNameAsPossessiveNoun(Departments.getKidsInternalName());
  return `${possessiveNoun} ${defaultSizeGuideHeader}${kidsHeaderPostfix}`;
};

export default SizeGuideHeader;
